var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-status-icon",style:({backgroundColor: _vm.status.color})},[_c('img',{attrs:{"src":require("../../../../assets/png/shuttle.png"),"alt":"shuttle"}})])}
var staticRenderFns = []

export { render, staticRenderFns }